module.exports = __webpack_public_path__ + "img/en-rise-smarthome-img.51f80515.jpg";